<template>
    <div>This item can't be previewed</div>
</template>

<script>
export default {
    name: "NoPreview"
}
</script>

<style></style>
